
            import "data:text/css,.m-deviceInfo-6c96c54f29%7Bdisplay:table;margin-left:0.5em;margin-right:0.5em;text-align:right;width:100%25;font-weight:600%7D.m-deviceInfoLabel-6c96c54f29%7Bcolor:#72727d;padding-right:0.5em%7D";
            const result = {"deviceInfo":"m-deviceInfo-6c96c54f29","deviceInfoLabel":"m-deviceInfoLabel-6c96c54f29"};
            export default result;
          